export const validationMessages = {
  title: "Title is required for edit process.",
  content: "Content is required for edit process.",
};
